import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (id) {
  try {
    await $apiFetch(API_ENDPOINTS.CUSTOMER_FOLLOWINGS_ID, {
      path: { id },
      method: 'DELETE'
    });

    return true;
  } catch (error) {
    Sentry.captureException(error);
  }

  return false;
}
